import React from "react";
import styled from "styled-components";

const Circle = styled.div`
  width: 4.2rem;
  height: 4.2rem;
  border: 2px solid ${props => props.color};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    fill: ${props => props.color};
  }
`;

export const SocialLink = ({ icon, url, color }) => {
  return (
    <a href={url} target="_blank" rel="noreferrer">
      <Circle color={color}>{icon}</Circle>
    </a>
  );
};
